import { render } from "./NavBar.vue?vue&type=template&id=39c19ad0&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"

import "./NavBar.vue?vue&type=style&index=0&id=39c19ad0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Oscar Daniel\\Desktop\\X LAUCHER\\TRABAJANDO\\05 - VUE\\Ejercio 2\\pasteleria-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c19ad0"]])

export default __exports__